import { z } from 'zod';

export const subscriptionInfoDTOSchema = z.object({
  monetizeNowAccountId: z.string().nullable(),
  monetizeNowProductIds: z.array(z.string()),
});

export type SubscriptionInfoDTO = z.output<typeof subscriptionInfoDTOSchema>;
